/* @flow */
import LayerWithArrow from 'components/LayerWithArrow.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/Hovercard.scss';

/**
 * Hovercard is a simple LayerWithArrow component
 *
 * Hovercard can be used with [HoverLayerTrigger](/components/HoverLayerTrigger) or
 * [LayerTrigger](/components/LayerTrigger).
 *
 * ```example
 *  <div>
 *    <HoverLayerTrigger
 *      layer={
 *        <Hovercard>
 *          <HovercardBody>
 *            Hello
 *          </HovercardBody>
 *        </Hovercard>
 *      }
 *      placement="top">
 *      <Link>Hover this link</Link>
 *    </HoverLayerTrigger>
 *    {' or '}
 *    <LayerTrigger
 *      layer={
 *        <Hovercard>
 *          <HovercardBody>
 *            Hello
 *          </HovercardBody>
 *        </Hovercard>
 *      }
 *      placement="top"
 *      trigger="click">
 *      <Link>Click this link</Link>
 *    </LayerTrigger>
 *  </div>
 * ```
 */

class Hovercard extends React.Component {
  static propTypes = {
    ...LayerWithArrow.propTypes,
  };

  render() {
    return (
      <LayerWithArrow
        {...this.props}
        className={cx('Hovercard', this.props.className)}
        arrowClassName="Hovercard-arrow">
        {this.props.children}
      </LayerWithArrow>
    );
  }
}

export default Hovercard;



// WEBPACK FOOTER //
// ./src/components/Hovercard.jsx